import { types } from './actions';

const initialState = {
  isSendInvitesModalOpen: false,
  isInvitesSentModalOpen: false,
  isInvitesSkippedModalOpen: false,
  isFetching: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEND_INVITES_REQUEST:
      return { ...state, isFetching: true };
    case types.SEND_INVITES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isInvitesSentModalOpen: true,
        isInviteModalOpen: false,
        isInvitesSkippedModalOpen: false,
      };
    case types.SEND_INVITES_ERROR:
      return { ...state, isFetching: false };
    case types.SEND_INVITES_MODAL_OPEN:
      return {
        ...state,
        isInviteModalOpen: true,
        isInvitesSentModalOpen: false,
        isInvitesSkippedModalOpen: false,
      };
    case types.SEND_INVITES_MODAL_CLOSE:
      return {
        ...state,
        isInviteModalOpen: false,
        isInvitesSentModalOpen: false,
        isInvitesSkippedModalOpen: true,
      };
    case types.INVITES_SENT_MODAL_CLOSE:
      return { ...state, isInvitesSentModalOpen: false };
    case types.INVITES_SKIPPED_MODAL_CLOSE:
      return { ...state, isInvitesSkippedModalOpen: false };
    default:
      return state;
  }
};

export default reducer;
